/* TestHelden · Über uns (/pages/ueber-uns): Kennzahlen zählen beim Einblenden einmal hoch.
   Der fertige Wert steht serverseitig im HTML (ohne JavaScript und für Suchmaschinen sichtbar); nur die erste Zahl im Text wird animiert,
   Format bleibt (Tausenderpunkt, Komma, „Mio.“, „+“). Keine Bewegung bei prefers-reduced-motion. */
(function () {
  if (window.__thuu) return; window.__thuu = true;
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function format(n, dez, punkt) {
    var s = n.toFixed(dez).replace('.', ',');
    if (punkt) { var t = s.split(','); t[0] = t[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); s = t.join(','); }
    return s;
  }
  function zaehlen(el) {
    var text = el.textContent, m = text.match(/\d{1,3}(?:\.\d{3})+|\d+(?:,\d+)?/);
    if (!m) return;
    var roh = m[0], punkt = roh.indexOf('.') > -1, dez = (roh.split(',')[1] || '').length;
    var ziel = parseFloat(roh.replace(/\./g, '').replace(',', '.'));
    if (!(ziel > 0)) return;
    var vor = text.slice(0, m.index), nach = text.slice(m.index + roh.length), start = null, dauer = 1400;
    el.style.minWidth = el.offsetWidth + 'px';
    function schritt(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dauer), e = 1 - Math.pow(1 - p, 3);
      el.textContent = vor + format(ziel * e, dez, punkt) + nach;
      if (p < 1) requestAnimationFrame(schritt); else { el.textContent = text; el.style.minWidth = ''; }
    }
    requestAnimationFrame(schritt);
  }
  function los() {
    var els = document.querySelectorAll('.thuu [data-uu-zahl]');
    if (ruhig || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); zaehlen(x.target); } });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
